import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Space from '@src/pc/hk/layout/components/space';

class BigImageAd extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return content.imageUrl ? (
            <>
                <Space content={30} />
                <a href={content.url} target="_blank" className={styles.bigImageAd}>
                    <img className={styles.bigImageAdPic} src={content.imageUrl} alt="" />
                </a>
            </>
        ) : null;
    }
}

export default errorBoundary(BigImageAd);
